import { Check } from "lucide-react";
import { cn } from "@/lib/utils";
import type { StoryImportStep } from "@/features/story-import/story-import.types";

interface StoryImportStepperProps {
  currentStep: StoryImportStep;
  labels: Record<StoryImportStep, string>;
  onStepSelect?: (step: StoryImportStep) => void;
}

const steps: StoryImportStep[] = [
  "upload",
  "credit-estimate",
  "processing",
];

export function StoryImportStepper({
  currentStep,
  labels,
  onStepSelect,
}: StoryImportStepperProps) {
  const activeIndex = steps.indexOf(currentStep);

  return (
    <ol className="grid gap-3 md:grid-cols-3">
      {steps.map((step, index) => {
        const isComplete = index < activeIndex;
        const isCurrent = step === currentStep;

        return (
          <li key={step}>
            <button
              className={cn(
                "flex w-full items-center gap-3 rounded-[1.5rem] border px-4 py-3 text-left transition",
                isCurrent
                  ? "border-ink/20 bg-white shadow-vellum"
                  : "border-white/60 bg-white/60 hover:bg-white/80",
              )}
              disabled={!onStepSelect}
              onClick={() => onStepSelect?.(step)}
              type="button"
            >
              <span
                className={cn(
                  "flex h-8 w-8 items-center justify-center rounded-full text-xs font-semibold",
                  isComplete || isCurrent
                    ? "bg-ink text-canvas"
                    : "bg-ink/10 text-ink/70",
                )}
              >
                {isComplete ? <Check className="h-4 w-4" /> : index + 1}
              </span>
              <span className="text-sm font-medium text-ink">{labels[step]}</span>
            </button>
          </li>
        );
      })}
    </ol>
  );
}
